import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMG } from "../data/site";
import { applySeoCustom } from "../lib/seo";
import { MaskedLines, Reveal } from "../components/site/Reveal";
import { CTABand } from "../components/site/CTABand";

const ALTERNATIVES = [
  { label: "Fortis Aluminium Doors", to: "/entrance-doors/fortis-aluminium-doors/", img: IMG.fortisD72, d: "Handcrafted in Britain, U-values to 0.71 W/m²K, PAS 24 certified, sizes up to 1.4m × 3m." },
  { label: "Kobbe Doors", to: "/entrance-doors/kobbe-doors/", img: IMG.kingswood, d: "Bold, striking entrance doors that transform the face of a property." },
  { label: "Composite Front Doors", to: "/entrance-doors/composite-front-doors/", img: IMG.originFront, d: "Endurance solid-core doors, robust, insulated, timber-look character." },
  { label: "All Entrance Doors", to: "/entrance-doors/", img: IMG.camberley, d: "Explore the full curated entrance door collection." },
];

export default function SpitfireDiscontinued() {
  useEffect(() => {
    applySeoCustom({ title: "Spitfire Doors — Range Update | Cedar Views", noindex: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="spitfire-discontinued-page" className="pt-32">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-12 pb-20">
        <Reveal><p className="overline-x mb-6">Range update</p></Reveal>
        <MaskedLines
          as="h1"
          lines={["We no longer stock", "Spitfire doors."]}
          delay={0.15}
          className="font-display tracking-tighter text-4xl sm:text-5xl lg:text-7xl text-white leading-[0.98]"
        />
        <Reveal delay={0.4} className="mt-8 max-w-2xl">
          <h2 className="text-base md:text-lg text-white/70 font-normal leading-relaxed">
            Our entrance door collection has moved on, and up. The alternatives below deliver the
            same luxury aluminium statement, with the craftsmanship, security and installation
            quality Cedar Views is known for.
          </h2>
        </Reveal>
      </section>

      <section className="border-t hairline bg-[#070E1D]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
          <Reveal><p className="overline-x mb-12">Choose your alternative</p></Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {ALTERNATIVES.map((a, i) => (
              <Reveal key={a.to} delay={(i % 2) * 0.1}>
                <Link to={a.to} data-testid={`spitfire-alt-${i}`} className="group block">
                  <div className="img-hover aspect-[16/10]">
                    <img src={a.img} alt={a.label} loading="lazy" className="w-full h-full object-cover" />
                  </div>
                  <div className="flex items-center justify-between mt-5">
                    <h3 className="font-display font-medium text-xl text-white">{a.label}</h3>
                    <ArrowRight size={18} className="text-white/40 group-hover:text-white group-hover:translate-x-1 transition-all" />
                  </div>
                  <p className="text-sm text-white/50 mt-2">{a.d}</p>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand product="Front & Back Doors" />
    </main>
  );
}
